export const ContractStatuses = {
  ACTIVE: "active",
  WARRANTY: "warranty",
  CLOSED: "closed"
};

export const ContractTabs = {
  SCOPE: "scope-of-work",
  PROCEDURES: "procedures",
  CONTACTS: "contacts",
  PLANS: "plans",
  PROCUREMENTS: "procurements",
  JOB_TRACKING: "job-tracking",
  WORK_ORDERS: "work-orders",
  NOTES: "notes"
};

export const ContractSubEntities = {
  PROCUREMENT: "App\\Procurement",
  WORK_ORDER: "App\\WorkOrder"
};

export const ScopeDocumentCondensedTypes = {
  DESIGN: "design",
  CONSTRUCTION: "construction",
  CHANGE_ORDER: "change_order"
};

export const ScopeDocumentTypes = {
  DESIGN_SHEETS: "design",
  DESIGN_ADDITIONAL: "additional",
  CONSTRUCTION: "construction",
  CHANGE_ORDER: "change_order"
};

export const ScopeDocumentTypeLabels = {
  [ScopeDocumentTypes.DESIGN_SHEETS]: "Design - required design sheets",
  [ScopeDocumentTypes.DESIGN_ADDITIONAL]: "Design - additional services",
  [ScopeDocumentTypes.CONSTRUCTION]: "Construction",
  [ScopeDocumentTypes.CHANGE_ORDER]: "Change Order"
};

export const Locations = {
  FRONT: "Front Yard",
  BACK: "Back yard",
  ENTIRE: "Entire Site"
};

export const Types = {
  NEW: "New Build",
  REMODEL: "Remodel"
};

export const ProcurementTypes = {
  ARCHITECT: "Architect",
  BUILDER: "Builder",
  CONSULTANT: "Consultant",
  EQUIPMENT: "Equipment",
  FURNITURE: "Furniture",
  GENERAL: "General",
  INTERIOR_DESIGNER: "Interior Designer",
  MASONRY: "Masonry",
  NURSERY: "Nursery"
};

export const ProcurementStatuses = {
  SCHEDULED: "scheduled",
  DELIVERED: "delivered",
  ON_HOLD: "on-hold",
  CANCELLED: "cancelled"
};

export const ProcurementStatusLabels = {
  [ProcurementStatuses.SCHEDULED]: "Scheduled",
  [ProcurementStatuses.DELIVERED]: "Delivered",
  [ProcurementStatuses.ON_HOLD]: "On-Hold",
  [ProcurementStatuses.CANCELLED]: "Cancelled"
};
